<template>
  <div>
    <v-card>
      <v-toolbar
        class="white--text"
        color="indigo"
        style="position: sticky; top: 0px; z-index: 1"
        dense
      >
        <v-toolbar-title>Gestione WO</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickSave"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-autocomplete
          :items="profili"
          @change="changeProfilo"
          v-model="tempProfilo"
          item-text="des_profilo_utente"
          label="profilo"
          class="mt-7"
          background-color="white"
          return-object
          outlined
          dense
          filled
        >
        </v-autocomplete>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickChiudi"
              small
              v-bind="attrs"
              v-on="on"
              class="ma-5"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-container>
        <v-tabs v-model="tab" background-color="indigo" center-active dark>
          <v-tabs-slider color="cyan"></v-tabs-slider>
          <v-tab>Pulsanti</v-tab>
          <v-tab>Informazioni</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item class="mt-5">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :items="pulsanti"
                    sort-by="ordine"
                    dense
                  >
                    <template v-slot:[`item.checkbox`]="{ item }">
                      <v-checkbox v-model="item.visible" dense> </v-checkbox>
                    </template>
                    <template v-slot:[`item.order`]="{ item }">
                      <v-btn @click="moveUp(item)" x-small>
                        <v-icon> mdi-menu-up </v-icon>
                      </v-btn>
                      <v-btn @click="moveDown(item)" x-small>
                        <v-icon> mdi-menu-down </v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:[`item.tooltip`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-text-field v-model="item.tooltip" v-else dense>
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.icona`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-select
                        :items="icons"
                        v-model="item.icona"
                        v-else
                        class="narrow"
                      >
                        <template v-slot:item="{ item }">
                          <v-icon> {{ item }} </v-icon>
                        </template>
                        <template v-slot:selection>
                          <v-icon>
                            {{ item.icona }}
                          </v-icon>
                        </template>
                      </v-select>
                    </template>
                    <template v-slot:[`item.colore_icona`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-select
                        :items="colors"
                        v-model="item.colore_icona"
                        v-else
                        class="narrow"
                      >
                        <template v-slot:item="{ item }">
                          <v-icon :color="item"> mdi-checkbox-blank </v-icon>
                        </template>
                        <template v-slot:selection>
                          <v-icon :color="item.colore_icona">
                            mdi-checkbox-blank
                          </v-icon>
                        </template>
                      </v-select>
                    </template>
                    <template v-slot:[`item.colore_sfondo`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-select
                        :items="colors"
                        v-model="item.colore_sfondo"
                        v-else
                        class="narrow"
                      >
                        <template v-slot:item="{ item }">
                          <v-icon :color="item"> mdi-checkbox-blank </v-icon>
                        </template>
                        <template v-slot:selection>
                          <v-icon :color="item.colore_sfondo">
                            mdi-checkbox-blank
                          </v-icon>
                        </template>
                      </v-select>
                    </template>
                    <template v-slot:[`item.colore_bloccato`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-icon class="success--text" v-else> mdi-check </v-icon>
                    </template>
                    <template v-slot:[`item.avanzato`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="clickImpostazioni(item)"
                            small
                            v-bind="attrs"
                            v-on="on"
                            class="ma-5"
                            :disabled="!(item.text == 'Apre Graph')"
                          >
                            <v-icon color="primary">mdi-cog</v-icon>
                          </v-btn>
                        </template>
                        <span>Impostazioni Avanzati</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>

          <v-tab-item class="mt-5">
            <v-card-text>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers_info"
                    :items="info"
                    sort-by="ordine"
                    dense
                  >
                    <template v-slot:[`item.checkbox`]="{ item }">
                      <v-checkbox v-model="item.visible" dense> </v-checkbox>
                    </template>
                    <template v-slot:[`item.order`]="{ item }">
                      <v-btn @click="moveUpInfo(item)" x-small>
                        <v-icon> mdi-menu-up </v-icon>
                      </v-btn>
                      <v-btn @click="moveDownInfo(item)" x-small>
                        <v-icon> mdi-menu-down </v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:[`item.text`]="{ item }">
                      <v-text-field v-model="item.tooltip" dense>
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.colore_bloccato`]="{ item }">
                      <v-icon class="error--text" v-if="item.colore_bloccato">
                        mdi-cancel
                      </v-icon>
                      <v-icon class="success--text" v-else> mdi-check </v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
      <!-- OLD TEMPLATE -->
      <!-- <v-card-text>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="pulsanti"
            sort-by="ordine"
            dense
          >
            <template v-slot:[`item.checkbox`]="{ item }">
              <v-checkbox v-model="item.visible" dense> </v-checkbox>
            </template>
            <template v-slot:[`item.order`]="{ item }">
              <v-btn @click="moveUp(item)" x-small>
                <v-icon> mdi-menu-up </v-icon>
              </v-btn>
              <v-btn @click="moveDown(item)" x-small>
                <v-icon> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.tooltip`]="{ item }">
              <v-icon class="error--text" v-if="item.colore_bloccato">
                mdi-cancel
              </v-icon>
              <v-text-field v-model="item.tooltip" v-else dense> </v-text-field>
            </template>
            <template v-slot:[`item.icona`]="{ item }">
              <v-icon class="error--text" v-if="item.colore_bloccato">
                mdi-cancel
              </v-icon>
              <v-select
                :items="icons"
                v-model="item.icona"
                v-else
                class="narrow"
              >
                <template v-slot:item="{ item }">
                  <v-icon> {{ item }} </v-icon>
                </template>
                <template v-slot:selection>
                  <v-icon>
                    {{ item.icona }}
                  </v-icon>
                </template>
              </v-select>
            </template>
            <template v-slot:[`item.colore_icona`]="{ item }">
              <v-icon class="error--text" v-if="item.colore_bloccato">
                mdi-cancel
              </v-icon>
              <v-select
                :items="colors"
                v-model="item.colore_icona"
                v-else
                class="narrow"
              >
                <template v-slot:item="{ item }">
                  <v-icon :color="item"> mdi-checkbox-blank </v-icon>
                </template>
                <template v-slot:selection>
                  <v-icon :color="item.colore_icona">
                    mdi-checkbox-blank
                  </v-icon>
                </template>
              </v-select>
            </template>
            <template v-slot:[`item.colore_sfondo`]="{ item }">
              <v-icon class="error--text" v-if="item.colore_bloccato">
                mdi-cancel
              </v-icon>
              <v-select
                :items="colors"
                v-model="item.colore_sfondo"
                v-else
                class="narrow"
              >
                <template v-slot:item="{ item }">
                  <v-icon :color="item"> mdi-checkbox-blank </v-icon>
                </template>
                <template v-slot:selection>
                  <v-icon :color="item.colore_sfondo">
                    mdi-checkbox-blank
                  </v-icon>
                </template>
              </v-select>
            </template>
            <template v-slot:[`item.colore_bloccato`]="{ item }">
              <v-icon class="error--text" v-if="item.colore_bloccato">
                mdi-cancel
              </v-icon>
              <v-icon class="success--text" v-else> mdi-check </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text> -->
    </v-card>
    <v-dialog v-model="advancedDialog" width="80vw">
      <v-card style="overflow-x: clip">
        <v-toolbar class="white--text" color="indigo" dense>
          <v-toolbar-title>Impostazioni Avanzati</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn
            @click="testMethod"
            small
            class="ma-5"
          >
            <v-icon color="success">mdi-plus</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickSaveAdv"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-5"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="advancedDialog = false"
                small
                v-bind="attrs"
                v-on="on"
                class="ma-5"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: scroll">
          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :items="dashboards"
                  label="Dashboard"
                  item-text="descrizione"
                  item-value="id_elemento"
                  v-model="selDashboard"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :items="
                    versions.filter((e) => {
                      return e.id_padre == selDashboard;
                    })
                  "
                  label="Versione"
                  item-text="descrizione"
                  item-value="id_elemento"
                  v-model="selVersione"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <QueryEditor v-model="queryObject" :template="queryTemplate" :key="queryKey">
            </QueryEditor>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";

export default {
  name: "GestionePulsanti",
  props: {},
  components: {
    SnackbarQV,
    QueryEditor,
  },
  data() {
    return {
        queryKey: true,
      id_query: -1,
      id_query_dettaglio: -1,
      queryObject: {},
      queryTemplate: [
        {
          targetProperty: "cod",
          color: "red",
          keyword: "@",
          targetField: "parametri",
          getTemplate(detail, code) {
            window.x = detail;
            return {
              id_query_preview: -1,
              id_query: -1,
              label: code,
              value: "",
              validita: 1,
            };
          },
        },
      ],
      advEditItem: {},
      dashboards: [],
      versions: [],
      selDashboard: null,
      selVersione: null,
      home: null,
      advancedDialog: false,
      loading: false,
      tab: null,
      tempProfilo: {},
      profili: [],
      info: [],
      pulsanti: [],
      colors: [
        "success",
        "error",
        "primary",
        "purple",
        "orange",
        "brown",
        "grey lighten-5",
        "indigo",
        "dark grey",
      ],
      icons: [
        "mdi-package-variant-closed-plus",
        "mdi-package-variant-closed",
        "mdi-account-convert",
        "mdi-cog-transfer-outline",
        "mdi-eye",
        "mdi-eye-off",
        "mdi-warehouse",
        "mdi-check",
        "mdi-cancel",
        "mdi-close",
        "mdi-floppy",
        "mdi-play",
        "mdi-stop",
        "mdi-cog",
        "mdi-plus",
        "mdi-pencil-ruler",
        "mdi-archive-cog-outline",
        "mdi-not-equal",
        "mdi-archive-clock-outline",
        "mdi-archive-outline",
        "mdi-send",
        "mdi-package-variant-remove",
        "mdi-chart-box",
      ],
      headers: [
        {
          text: "Visibile",
          value: "checkbox",
        },
        {
          text: "Ordine",
          value: "order",
        },
        {
          text: "Nome",
          value: "text",
        },
        {
          text: "Descrizione",
          value: "tooltip",
        },
        {
          text: "Icona",
          value: "icona",
        },
        {
          text: "Colore Icona",
          value: "colore_icona",
        },
        {
          text: "Colore Sfondo",
          value: "colore_sfondo",
        },
        {
          text: "Modificabile",
          value: "colore_bloccato",
        },
        {
          text: "Avanzato",
          value: "avanzato",
        },
      ],
      headers_info: [
        {
          text: "Visibile",
          value: "checkbox",
        },
        {
          text: "Ordine",
          value: "order",
        },
        {
          text: "Nome",
          value: "text",
        },
        {
          text: "Value",
          value: "value",
        },
        {
          text: "Modificabile",
          value: "colore_bloccato",
        },
      ],
    };
  },
  mounted() {
    this.inizializza();
  },
  methods: {
    clickSaveAdv() {
      console.log(this.queryObject);
      console.log(this.queryTemplate);
      console.log(this.selDashboard);
      console.log(this.selVersione);
      this.advEditItem.fields =
        this.selDashboard.toString() + "," + this.selVersione.toString();

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setquerydettaglio",
          token: localStorage.user_token,
          tabella: [
            {
              id_query: this.id_query,
              titolo: "Query Work Order",
              modulo: "Avanzameno",
              colonne: [],
              query: [
                {
                  id_query_dettaglio: this.id_query_dettaglio,
                  id_query: this.id_query,
                  query: this.queryObject.query,
                  validita: 1,
                },
              ],
              params: [],
            },
          ],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.advEditItem.query = res.data[0].id_query;
          this.$refs.SnackbarQV.print(
            "success",
            "Query Graph per profilo " +
              this.tempProfilo.des_profilo_utente +
              " salvato con successo"
          );
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Query Graph per profilo " +
              this.tempProfilo.des_profilo_utente +
              " non salvato"
          );
        }
      });

      this.advancedDialog = false;
    },
    clickImpostazioni(arg) {
      this.advEditItem = arg;
      if (arg.query != null) {
        this.id_query = arg.query;
        this.getQuery();
      }
      this.getDashboards();
      console.log(this.advEditItem.fields);
      if (
        this.advEditItem.fields != null &&
        this.advEditItem.fields.includes(",")
      ) {
        this.selDashboard = parseInt(this.advEditItem.fields.split(",")[0]);
        this.selVersione = parseInt(this.advEditItem.fields.split(",")[1]);
      }
      this.advancedDialog = true;
    },
    testMethod() {
      console.log(this.queryObject);
      this.queryKey = !this.queryKey;
    },
    getQuery() {
      this.dashboards = [];
      this.versions = [];
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          id_query: this.id_query,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          console.log(res.data.result);
          this.id_query_dettaglio = res.data.result.query[0].query1[0].id_query_dettaglio;
          this.queryObject = {
            query: res.data.result.query[0].query1[0].query,
          };
          console.log(this.queryObject);
          this.loading = false;
        }
      });
    },
    getDashboards() {
      this.dashboards = [];
      this.versions = [];
      const request = {
        controller: "Graph",
        method: "POST",
        richiesta: {
          action: "gethome",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.home = res.data;
          res.data.struttura.forEach((e) => {
            if (e.tipo == 1) {
              this.dashboards.push(JSON.parse(JSON.stringify(e)));
              this.versions.push({
                descrizione: "Versione di default",
                id_elemento: 0,
                id_padre: e.id_elemento,
              });
            } else if (e.tipo == 2) {
              this.versions.push(JSON.parse(JSON.stringify(e)));
            }
          });
          this.loading = false;
        }
      });
    },
    inizializza() {
      this.loading = true;
      this.pulsanti = [];
      this.info = [];
      this.utenti = [];

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getprofili",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          for (let i = 0; i < res.data.length; i++) {
            this.profili.push(Object.assign({}, res.data[i]));
          }
          this.loading = false;
        }
      });
    },
    moveUp(item) {
      // Assegno un ordine "sicuro" ai pulsanti.
      for (let p = 0; p < this.pulsanti.length; p++) {
        this.pulsanti[p].ordine = p;
      }

      // Registro l'indice del pulsante selezionato.
      let idx_sel = -1;

      for (let p = 0; p < this.pulsanti.length; p++) {
        if (this.pulsanti[p].text === item.text) {
          idx_sel = p;
        }
      }

      // Se è il caso, riordino.
      if (idx_sel > 0) {
        this.pulsanti[idx_sel].ordine -= 1;
        this.pulsanti[idx_sel - 1].ordine += 1;

        this.pulsanti.sort((a, b) => a.ordine - b.ordine);
      }
    },
    moveUpInfo(item) {
      // Assegno un ordine "sicuro" ai dati.
      for (let i = 0; i < this.info.length; i++) {
        this.info[i].ordine = i;
      }

      // Registro l'indice del pulsante selezionato.
      let idx_sel = -1;

      for (let i = 0; i < this.info.length; i++) {
        if (this.info[i].text === item.text) {
          idx_sel = i;
        }
      }

      // Se è il caso, riordino.
      if (idx_sel > 0) {
        this.info[idx_sel].ordine -= 1;
        this.info[idx_sel - 1].ordine += 1;

        this.info.sort((a, b) => a.ordine - b.ordine);
      }
    },
    moveDown(item) {
      // Assegno un ordine "sicuro" ai pulsanti.
      for (let p = 0; p < this.pulsanti.length; p++) {
        this.pulsanti[p].ordine = p;
      }

      // Registro l'indice del pulsante selezionato.
      let idx_sel = -1;

      for (let p = 0; p < this.pulsanti.length; p++) {
        if (this.pulsanti[p].text === item.text) {
          idx_sel = p;
        }
      }

      // Se è il caso, riordino.
      if (idx_sel < this.pulsanti.length - 1) {
        this.pulsanti[idx_sel].ordine += 1;
        this.pulsanti[idx_sel + 1].ordine -= 1;

        this.pulsanti.sort((a, b) => a.ordine - b.ordine);
      }
    },
    moveDownInfo(item) {
      // Assegno un ordine "sicuro" ai dati.
      for (let i = 0; i < this.info.length; i++) {
        this.info[i].ordine = i;
      }

      // Registro l'indice del pulsante selezionato.
      let idx_sel = -1;

      for (let i = 0; i < this.info.length; i++) {
        if (this.info[i].text === item.text) {
          idx_sel = i;
        }
      }

      // Se è il caso, riordino.
      if (idx_sel < this.info.length - 1) {
        this.info[idx_sel].ordine += 1;
        this.info[idx_sel + 1].ordine -= 1;

        this.info.sort((a, b) => a.ordine - b.ordine);
      }
    },
    changeProfilo() {
      this.loading = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          id_profilo: this.tempProfilo.id_profilo_utente,
          tipo_oggetto: "B",
          tipo_query: "tabella",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.pulsanti = [];
          this.info = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].tipo_oggetto == "B") {
              this.pulsanti.push(Object.assign({}, res.data[i]));
            } else if (res.data[i].tipo_oggetto == "D") {
              this.info.push(Object.assign({}, res.data[i]));
            }
          }

          // Assegno un ordine "sicuro" ai pulsanti.
          this.pulsanti.sort((a, b) => a.ordine - b.ordine);
          for (let p = 0; p < this.pulsanti.length; p++) {
            this.pulsanti[p].ordine = p;
          }

          // Assegno un ordine "sicuro" alle info.
          this.info.sort((a, b) => a.ordine - b.ordine);
          for (let i = 0; i < this.info.length; i++) {
            this.info[i].ordine = i;
          }
        }
        this.loading = false;
      });
    },
    clickSave() {
      this.loading = true;
      for (let i = 0; i < this.pulsanti.length; i++) {
        this.pulsanti[i]["id_profilo"] = this.tempProfilo.id_profilo_utente;
      }

      for (let i = 0; i < this.info.length; i++) {
        this.info[i]["id_profilo"] = this.tempProfilo.id_profilo_utente;
      }

      const arr = this.pulsanti.concat(this.info);
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setheader",
          header: arr,
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Pulsanti per profilo " +
                this.tempProfilo.des_profilo_utente +
                " salvati con successo"
            );
            this.loading = false;
            this.changeProfilo();
          } else {
            this.loading = false;
            this.$refs.SnackbarQV.print("orange", "Pulsanti non salvati");
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
          this.$refs.SnackbarQV.print("error", "Pulsanti non salvati");
        });
    },
    clickChiudi() {
      let evento = new CustomEvent("cambia_pulsanti");
      document.getElementById("listener_carrello_insit").dispatchEvent(evento);
      this.$emit("click_chiudi");
    },
  },
};
</script>
<style scoped>
.narrow {
  width: 75px;
}
</style>